import { isIP } from 'is-ip';
var parseUrl = function (url) {
    var _a = new URL(url), host = _a.host, hostname = _a.hostname, protocol = _a.protocol;
    if (isIP(hostname)) {
        return { domain: host, protocol: protocol };
    }
    var hostArr = host.split('.');
    var subdomain = hostArr[0];
    var domain = hostArr.slice(1).join('.');
    return { domain: domain, protocol: protocol, subdomain: subdomain };
};
export var getBaseUrl = function () {
    var _a = parseUrl(window.location.href), domain = _a.domain, protocol = _a.protocol;
    var apiPath = 'api/v1';
    return "".concat(protocol, "//").concat(domain, "/").concat(apiPath);
};
